import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  const user = localStorage.getItem("user");

  // Si el token o el usuario están ausentes, redirige al login
  if (!token || !user) {
    return <Navigate to="/login" />;
  }

  // Si el usuario está autenticado, renderiza el componente hijo
  return children;
};

export default ProtectedRoute;
